import ApiPermisos from './../../services/apiPermisos'
import {searchEmployeeByLocation} from '../../../src/services/health-tracker/ges/service'

export default {
    namespaced: true,
    state: {
        new_format_error: { exist: false, message: null },
        loading: false,
        loading2: false,
        loading3: false,
        loadingDiagnostics:false,
        error:{},
        message:{},
        employeesBySearch:[],
        employeeInfo:{},
        typesAbsenteeism:[],
        groupsDiagnostics:[],
        diagnostics:[],
        riskClassification:[],
        listsAbsenteeism:{},
        absenteeism:{},
        historyAbs:{},
        detailAbs:{},
        previousUser:'',
        filters:{},
        societys:[],
        areas:[],
        summary:{},
        tableReport:{},
        tablePhoto:{},
        tablePhone:{},
        responsiblePhoto:{},
        responsiblePhone:{},
        employeeInfoPhone:{},
        progressBarPhotos:{},
        progressBarPhones:{},
    },
    getters: {
        getEmployeesBySearch : (state) => { return state.employeesBySearch }
        , getEmployeeInfo : (state) => { return state.employeeInfo }
        , getGroupsDiagnostics: (state) => { return state.groupsDiagnostics }
        , getDiagnostics: (state) => { return state.diagnostics }

    },
    mutations: {
        setLoading: (state, loading) => {
            state.loading = loading;
        },
        setLoading2: (state, loading2) => {
          state.loading2 = loading2;
        },
        setLoading3: (state, loading3) => {
        state.loading3 = loading3;
        },
        setLoadingDiagnostics: (state, loadingDiagnostics) => {
          state.loadingDiagnostics = loadingDiagnostics;
        },
        setError:(state, error) => {
            state.error.message = error  
        },
        setMessage:(state, message) => {
            state.error = {}
            state.message = message  
        },
        setEmployeesBySearch:(state, employeesBySearch) => { 
          state.employeesBySearch = employeesBySearch.data
        },
        setEmployeeInfo:(state) => {
          let employeeInfo = localStorage.getItem('employee')
          state.employeeInfo = JSON.parse(employeeInfo)
        },
        setTypesAbsenteeism:(state, typesAbsenteeism) => {
            state.typesAbsenteeism = typesAbsenteeism.data
        },
        setGroupsDiagnostics:(state, groupsDiagnostics) => {
            state.groupsDiagnostics = groupsDiagnostics.data
        },
        setDiagnostics:(state, diagnostics) => {
            state.diagnostics = diagnostics.data
        },
        setRiskClassification:(state, riskClassification) => { 
            state.riskClassification = riskClassification.data
        },
        setListsAbsenteeism:(state, listsAbsenteeism) => { 
          state.listsAbsenteeism = listsAbsenteeism
        },
        setAbsenteeism:(state, absenteeism) => {
          state.absenteeism = absenteeism.data
        },
        setHistoryAbs:(state, historyAbs) => {
          state.historyAbs = historyAbs.data
        },
        setDetailAbsenteeism:(state,detailAbs) => {
          state.detailAbs = detailAbs
        },
        setpreviousUser:(state,previousUser) => {
          state.previousUser = previousUser
        },
        setFilterEmployeeDetail:(state,filters) => {
          state.filters = filters.data
        },
        setSocietys:(state,societys) => {
          state.societys = societys.data
        },
        setAreas:(state,areas) => {
          state.areas = areas.data
        },
        setSummary:(state,summary) => {
          state.summary = summary.data
        },
        setTablesReport:(state,tableReport) => { 
          state.tableReport = tableReport.data
        },
        setTableEmployeePhotos:(state,tablePhoto) => {
          state.tablePhoto = tablePhoto.data
        },
        setTableEmployeePhone:(state,tablePhone) => {
          state.tablePhone = tablePhone.data
        },
        setResponsiblePhotos:(state,responsiblePhoto) => {
          state.responsiblePhoto = responsiblePhoto.data
        },
        setResponsiblePhones:(state,responsiblePhone) => {
          state.responsiblePhone = responsiblePhone.data
        },
        employeePhone:(state,employeeInfoPhone) => {
          state.employeeInfoPhone = employeeInfoPhone.data
        },
        setProgressBarPhotos:(state,progressBarPhotos) => {
          state.progressBarPhotos = progressBarPhotos.data
        },
        setProgressBarPhones:(state,progressBarPhones) => {
          state.progressBarPhones = progressBarPhones.data
        },
        SET_NEW_FORMAT_ERROR: (state, data = { exist: false, message: null }) => {
            state.new_format_error = data
        }
    },
    actions: {   

      //Trae los empleados por la busqueda

      actGetEmployeesBySearch: async ({
        commit
      },data) => {
        try {
          let response = await searchEmployeeByLocation(data);
          if (response.error) {
              commit('setError', response.error.trace.message[0]);
              return response.error;
          }
          else{
            commit('setEmployeesBySearch',response );
          }
        } catch (error) {
          commit('setLoading', false);
          let error2 = error.response
          commit('setError', error2.data.message);
        }
      },
      
       //Trae la Información basica del empleado seleccionado

    actGetEmployeeInfo: async ({
      commit
    },id) => {
      try {
        commit('setLoading', true);
        let response = await ApiPermisos.getEmployeeInfo(id);
        commit('setLoading', false);
        if (response.error) {
            commit('setError', response.error.trace.message[0]);
            return response.error;
        }
        else{
          localStorage.setItem('employee', JSON.stringify(response));
          commit('setEmployeeInfo');
        }
      } catch (error) {
        commit('setLoading', false);
        let error2 = error.response
        commit('setError', error2.data.message);
      }
    },

       //Trae la Información basica del empleado en el LocalStorage

       actGetEmployeeInfoLocal: ({commit}) => {
            commit('setEmployeeInfo');
    },


    actGetEmployeeInfoResponsible: async ({
      commit
    },id) => {
      try {
        commit('setLoading2', true);
        let response = await ApiPermisos.getEmployeeInfo(id);
        commit('setLoading2', false);
        if (response.error) {
            commit('setError', response.error.trace.message[0]);
            return response.error;
        }
        else{
          commit('setEmployeeInfo', response);
        }
      } catch (error) {
        commit('setLoading', false);
        let error2 = error.response
        commit('setError', error2.data.message);
      }
    },
  
      //Trae los tipos de ausentismos => lleva una busqueda

    actGetTypesAbsenteeism: async ({
        commit
      },search) => {
        try {
          let response = await ApiPermisos.getTypesAbsenteeism(search);
          if (response.error) {
              commit('setError', response.error.trace.message[0]);
              return response.error;
          }
          else{
            commit('setTypesAbsenteeism', response);
          }
        } catch (error) {
          let error2 = error.response
          commit('setError', error2.data.message);
        }
      },

        //Trae los grupos de diagnosticos => lleva una busqueda

    actGetGroupsDiagnostics: async ({
        commit
      },search) => {
        try {
          let response = await ApiPermisos.getGroupsDiagnostics(search);
          if (response.error) {
              commit('setError', response.error.trace.message[0]);
              return response.error;
          }
          else{
            commit('setGroupsDiagnostics', response);
          }
        } catch (error) {
          let error2 = error.response
          commit('setError', error2.data.message);
        }
      },

         //Trae los grupos de diagnosticos => lleva una busqueda

    actGetDiagnostics: async ({
        commit
      },search) => {
        try {
          commit('setLoadingDiagnostics', true);
          let response = await ApiPermisos.getDiagnostics(search);
          commit('setLoadingDiagnostics', false);
          if (response.error) {
              commit('setError', response.error.trace.message[0]);
              return response.error;
          }
          else{
            commit('setDiagnostics', response);
          }
        } catch (error) {
          let error2 = error.response
          commit('setError', error2.data.message);
        }
      },

       //Trae los grupos de diagnosticos => lleva una busqueda

    actGetRiskClassification: async ({
        commit
      },search) => {
        try {
          let response = await ApiPermisos.getRiskClassification(search);
          if (response.error) {
              commit('setError', response.error.trace.message[0]);
              return response.error;
          }
          else{
            commit('setRiskClassification', response);
          }
        } catch (error) {
          let error2 = error.response
          commit('setError', error2.data.message);
        }
      },

        //Trae las listas desplegables del formulario de Creación de ausentismos

    actGetListsAbsenteeism: async ({
      commit
    }) => {
      try {
        commit('setLoading2', true);
        let response = await ApiPermisos.getListsAbsenteeism();
        commit('setLoading2', false);
        if (response.error) {
            commit('setError', response.error.trace.message[0]);
            return response.error;
        }
        else{
          commit('setListsAbsenteeism', response);
        }
      } catch (error) {
        let error2 = error.response
        commit('setError', error2.data.message);
      }
    },
       //Guarda el Ausentismo  getAbsenteeism

       async actSaveAbsenteeism ({ commit }, data) {
          const response = await ApiPermisos.saveAbsenteeism(data)
           commit('setMessage', response)
        /*try {
          // commit('setLoading', true);
          let response = await ApiPermisos.saveAbsenteeism(data);
          // commit('setLoading', false);
          if (response.error) {
              commit('setError', response.error.trace.message[0]);
              return response.error;
          }
          else{
            commit('setMessage', response);
          }
        } catch (error) {
          let error2 = error.response
          commit('setError', error2.data.message);
        }*/
      },

      //Trae un Ausentismo por ID 

      actGetAbsenteeism: async ({
        commit
      }, id) => {
        try {
          commit('setLoading2', true);
          let response = await ApiPermisos.getAbsenteeismHT(id);
          commit('setLoading2', false);
          if (response.error) {
              commit('setError', response.error.trace.message[0]);
              return response.error;
          }
          else{
            commit('setAbsenteeism', response);
          }
        } catch (error) {
          let error2 = error.response
          commit('setError', error2.data.message);
        }
      },

      //Actualiza el ausentismo

      actActAbsenteeism: async ({
        commit
      }, data) => {
        try {
          commit('setLoading2', true);
          let response = await ApiPermisos.actAbsenteeism(data);
          commit('setLoading2', false);
          if (response.error) {
              commit('setError', response.error.trace.message[0]);
              return response.error;
          }
          else{
            commit('setMessage', response);
          }
        } catch (error) {
          let error2 = error.response
          commit('setError', error2.data.message);
        }
      },

      //Consulta el historial de modificaciones en los ausentismos

      actGetHistoryOfAbsenteeism: async ({
        commit
      }, data) => {
        try {
          commit('setLoading2', true);
          let response = await ApiPermisos.getHistoryOfAbsenteeism(data);
          commit('setLoading2', false);
          if (response.error) {
              commit('setError', response.error.trace.message[0]);
              return response.error;
          }
          else{
            commit('setHistoryAbs', response);
          }
        } catch (error) {
          let error2 = error.response
          commit('setError', error2.data.message);
        }
      },

      //Consulta el detalle de los ausentismos

      actGetDetailAbsenteeism: async ({
        commit
      }, data) => {
        try {
          commit('setLoading', true);
          let response = await ApiPermisos.getDetailAbsenteeism(data);
          commit('setLoading', false);
          if (response.error) {
              commit('setError', response.error.trace.message[0]);
              return response.error;
          }
          else{
            commit('setDetailAbsenteeism', response);
          }
        } catch (error) {
          let error2 = error.response
          commit('setError', error2.data.message);
        }
      },

      //Establece el usuario en detalle 

      actPreviousUser: async ({
        commit
      }, id) => {
        commit('setpreviousUser', id) 
      },

      //Carga el archivo de empleados de HT

      actSaveFileEmployeeHT: async ({ commit, dispatch }, data) => {
          commit('setLoading2', true)

          const { success, result, error, message  } = await ApiPermisos.saveFileEmployeeHT(data).finally(() => {
              commit('setLoading2', false)
          })
          dispatch('map_new_data', { success, result, error, message })

              /*.then(( response  ) => {
              console.log(response)
              //commit('setMessage', result)
          }).catch(({ response: { data: { message }} }) => {
              alert(message)
              commit('setError', message)
          }).finally(() => {
              commit('setLoading2', false)
          })

          commit('setLoading2', false)

        /*try {
          commit('setLoading2', true);
          let response = await ApiPermisos.saveFileEmployeeHT(data);
          commit('setLoading2', false);

          /*if (response.error) {
              commit('setError', response.error.trace.message[0]);
              return response.error;
          }
          else{
            commit('setMessage', response);
          }
            console.log(response)
        } catch (error) {
          /*let error2 = error.response
          commit('setError', error2.data.message);
            console.log(error.response)
        }*/
      },

      //Carga el archivo de empleados de HT

      actSaveFileAbs: async ({
        commit
      }, data) => {
          try {
              commit('setLoading2', true);
              const { error, message } = await ApiPermisos.saveFileAbs(data).finally(() => {
                  commit('setLoading2', false)
              })
              if (error === true ) {
                  const { trace: { message:message_trance } } = error
                  const data = { exist: true, message: message_trance[0] ?? message }
                  commit('SET_NEW_FORMAT_ERROR', data)
              } else {
                  const data = { exist: false, message: null }
                  commit('SET_NEW_FORMAT_ERROR', data)
                  commit('setMessage', message)
              }
          } catch ({ response: { data: { message } } }) {
              const data = { exist: true, message: message }
              commit('SET_NEW_FORMAT_ERROR', data)
          }


          /*try {


          let response = await ApiPermisos.saveFileAbs(data);
          commit('setLoading2', false);
          if (response.error) {
              commit('setError', response.error.trace.message[0]);
              return response.error;
          }
          else{
            commit('setMessage', response);
          }
        } catch (error) {
          let error2 = error.response
          commit('setError', error2.data.message);
        }*/
      },

      //Carga el archivo de empleados de HT 

      actFilterEmployeeDetail: async ({
        commit
      }, id) => {
        try {
          commit('setLoading2', true);
          let response = await ApiPermisos.filterEmployeeDetail(id);
          commit('setLoading2', false);
          if (response.error) {
              commit('setError', response.error.trace.message[0]);
              return response.error;
          }
          else{
            commit('setFilterEmployeeDetail', response);
          }
        } catch (error) {
          let error2 = error.response
          commit('setError', error2.data.message);
        }
      },

      //Trae todas las sociedades

      actGetAllSocietys: async ({
        commit
      }) => {
        try {
          commit('setLoading', true);
          let response = await ApiPermisos.getAllSocietys();
          commit('setLoading', false);
          if (response.error) {
              commit('setError', response.error.trace.message[0]);
              return response.error;
          }
          else{
            commit('setSocietys', response);
          }
        } catch (error) {
          let error2 = error.response
          commit('setError', error2.data.message);
        }
      },

      //Trae todas las areas

      actGetAllAreas: async ({
        commit
      }, id) => {
        try {
          commit('setLoading', true);
          let response = await ApiPermisos.getAllAreas(id);
          commit('setLoading', false);
          if (response.error) {
              commit('setError', response.error.trace.message[0]);
              return response.error;
          }
          else{
            commit('setAreas', response);
          }
        } catch (error) {
          let error2 = error.response
          commit('setError', error2.data.message);
        }
      },

      //Trae todas las areas

      actFilterStadisticsBy: async ({
        commit
      }, data) => {
        try {
          commit('setLoading', true);
          let response = await ApiPermisos.filterStadistics(data);
          commit('setLoading', false);
          if (response.error) {
              commit('setError', response.error.trace.message[0]);
              return response.error;
          }
          else{
            commit('setSummary', response);
          }
        } catch (error) {
          let error2 = error.response
          commit('setError', error2.data.message);
        }
      },

      //Trae todas las areas

      actGetTablesReport: async ({
        commit
      }, data) => {
        try {
          commit('setLoading', true);
          let response = await ApiPermisos.getTablesReport(data);
          commit('setLoading', false);
          if (response.error) {
              commit('setError', response.error.trace.message[0]);
              return response.error;
          }
          else{
            commit('setTablesReport', response);
          }
        } catch (error) {
          let error2 = error.response
          commit('setError', error2.data.message);
        }
      },

      //Trae las tablas de empleados con foto actCheckEmployeesWithPhone

      actCheckEmployeesWithPhoto: async ({
        commit
      }, data) => {
        try {
          commit('setLoading3', true);
          let response = await ApiPermisos.checkEmployeesWithPhoto(data);
          commit('setLoading3', false);
          if (response.error) {
              commit('setError', response.error.trace.message[0]);
              return response.error;
          }
          else{
            commit('setTableEmployeePhotos', response);
          }
        } catch (error) {
          let error2 = error.response
          commit('setError', error2.data.message);
        }
      },

      //Trae el responsable de las fotos 

      actResponsiblePhotos: async ({
        commit
      }) => {
        try {
          commit('setLoading2', true);
          let response = await ApiPermisos.checkResponsiblePhotos();
          commit('setLoading2', false);
          if (response.error) {
              commit('setError', response.error.trace.message[0]);
              return response.error;
          }
          else{
            commit('setResponsiblePhotos', response);
          }
        } catch (error) {
          let error2 = error.response
          commit('setError', error2.data.message);
        }
      },

      //Trae el responsable de los Telefonós

      actResponsiblePhones: async ({
        commit
      }) => {
        try {
          commit('setLoading2', true);
          let response = await ApiPermisos.checkResponsiblePhones();
          commit('setLoading2', false);
          if (response.error) {
              commit('setError', response.error.trace.message[0]);
              return response.error;
          }
          else{
            commit('setResponsiblePhones', response);
          }
        } catch (error) {
          let error2 = error.response
          commit('setError', error2.data.message);
        }
      },

      //Asigna un responsable de las fotos actAssignResponsiblePhone

      actAssignResponsiblePhotos: async ({
        commit
      },id) => {
        try {
          commit('setLoading2', true);
          let response = await ApiPermisos.assignResponsiblePhotos(id);
          commit('setLoading2', false);
          if (response.error) {
              commit('setError', response.error.trace.message[0]);
              return response.error;
          }
          else{
            commit('setMessage', response);
          }
        } catch (error) {
          let error2 = error.response
          commit('setError', error2.data.message);
        }
      },

      //Asigna un responsable de los telefonos

      actAssignResponsiblePhone: async ({
        commit
      },id) => {
        try {
          commit('setLoading2', true);
          let response = await ApiPermisos.assignResponsiblePhones(id);
          commit('setLoading2', false);
          if (response.error) {
              commit('setError', response.error.trace.message[0]);
              return response.error;
          }
          else{
            commit('setMessage', response);
          }
        } catch (error) {
          let error2 = error.response
          commit('setError', error2.data.message);
        }
      },

      //Trae las tablas de empleados con teléfono

      actCheckEmployeesWithPhone: async ({
        commit
      }, data) => {
        try {
          commit('setLoading3', true);
          let response = await ApiPermisos.checkEmployeesWithPhone(data);
          commit('setLoading3', false);
          if (response.error) {
              commit('setError', response.error.trace.message[0]);
              return response.error;
          }
          else{
            commit('setTableEmployeePhone', response);
          }
        } catch (error) {
          let error2 = error.response
          commit('setError', error2.data.message);
        }
      },

       //Carga las fotos de los empleados

       actUploadImagesEmployees: async ({ commit },images) => {
           commit('setLoading2', true)
           commit('setMessage', {})
           commit('setError', null)
           await ApiPermisos.uploadImagesEmployees(images).then(({ error, success, result, message, error_code }) => {
              if(error) {
                const { detail } = error
                commit('setError', detail)
              } else {
                commit('setMessage', { success, result, message, error_code })
              }
           }).catch(({ response: { data: { message }} }) => {
               commit('setError', message)
           }).finally(() =>
               commit('setLoading2', false)
           )

           //const { success, result, message } = await ApiPermisos.uploadImagesEmployees(images).finally(() => commit('setLoading2', false))
           /*console.log(success)
           console.log(result)
           console.log(message)
           if (success) {
               alert(result)
               commit('setError')
               commit('setMessage', result)
           } else {
               commit('setError', message)
               alert(result)
               alert(message)
           }*/

           /*try {
             commit('setLoading2', true);
             let response = await ApiPermisos.uploadImagesEmployees(images);
             commit('setLoading2', false);
             if (response.error) {
                 commit('setError', response.error.trace.message[0]);
                 return response.error;
             }
             else{
               commit('setMessage', response);
             }
           } catch (error) {
             let error2 = error.response
             commit('setError', error2.data.message);
           }*/
      },

       //Carga las teléfonos de los empleados

       actUploadPhonesEmployees: async ({
        commit
      },phones) => {
        try {
          commit('setLoading2', true);
          let response = await ApiPermisos.uploadPhonesEmployees(phones);
          commit('setLoading2', false);
          if (response.error) {
              commit('setError', response.error.trace.message[0]);
              return response.error;
          }
          else{
            commit('setMessage', response);
          }
        } catch (error) {
          let error2 = error.response
          commit('setError', error2.data.message);
        }
      },

      //Trae la info del empleado incluyendo el teléfono

      actGetEmployeePhone: async ({
        commit
      }, id) => {
        try {
          commit('setLoading3', true);
          let response = await ApiPermisos.getEmployeePhone(id);
          commit('setLoading3', false);
          if (response.error) {
              commit('setError', response.error.trace.message[0]);
              return response.error;
          }
          else{
            commit('employeePhone', response);
          }
        } catch (error) {
          let error2 = error.response
          commit('setError', error2.data.message);
        }
      },

       //Carga las teléfonos de los empleados

       actSaveEmployeePhone: async ({
        commit
      },data) => {
        try {
          commit('setLoading2', true);
          let response = await ApiPermisos.saveEmployeePhone(data);
          commit('setLoading2', false);
          if (response.error) {
              commit('setError', response.error.trace.message[0]);
              return response.error;
          }
          else{
            commit('setMessage', response);
          }
        } catch (error) {
          let error2 = error.response
          commit('setError', error2.data.message);
        }
      },

        //Revisa el progreso de la carga de telefonos de los empleados

        actGetProgressBarPhones: async ({
        commit
      }) => {
        try {
          commit('setLoading3', true);
          let response = await ApiPermisos.getProgressBarPhones();
          commit('setLoading3', false);
          if (response.error) {
              commit('setError', response.error.trace.message[0]);
              return response.error;
          }
          else{
            commit('setProgressBarPhones', response);
          }
        } catch (error) {
          let error2 = error.response
          commit('setError', error2.data.message);
        }
      },

      //Revisa el progreso de la carga de fotos de los empleados

      actGetProgressBarPhotos: async ({
        commit
      }) => {
        try {
          commit('setLoading3', true);
          let response = await ApiPermisos.getProgressBarPhotos();
          commit('setLoading3', false);
          if (response.error) {
              commit('setError', response.error.trace.message[0]);
              return response.error;
          }
          else{
            commit('setProgressBarPhotos', response);
          }
        } catch (error) {
          let error2 = error.response
          commit('setError', error2.data.message);
        }
      },

       //Guarda el archivo de historico Laboral

       actUploadFileHistoryWorker: async ({
        commit
      }, data) => {
        try {
          commit('setLoading2', true);
          let response = await ApiPermisos.uploadFileHistoryWorker(data);
          commit('setLoading2', false);
          if (response.error) {
              commit('setError', response.error.trace.message[0]);
              return response.error;
          }
          else{
            commit('setMessage', response);
          }
        } catch (error) {
          let error2 = error.response
          commit('setError', error2.data.message);
        }
      },

        /**
         * Subir el achivo CIE-10
         **/
        async act_upload_file_cie10 ({ commit, dispatch }, data) {
            commit('setLoading2', true)
            const { success, result , error, message } = await ApiPermisos.save_file_cie_10_ht(data).finally(() => {
                commit('setLoading2', false)
            })
            dispatch('map_new_data', { success, result, error, message })
        },
        map_new_data ({ commit }, { success, result , error, message }) {
            if (error) {
                const { detail: { file } } = error
                const data = { exist: true, message: file[0] }
                commit('SET_NEW_FORMAT_ERROR', data)
            }
            if (success === false) {
                const data = { exist: true, message }
                commit('SET_NEW_FORMAT_ERROR', data)
            }
            if (success === true) {
                const data = { exist: false, message: null }
                commit('SET_NEW_FORMAT_ERROR', data)
                commit('setMessage', result)
            }
        }
    },
  }
  